// assets/project/src/stores/locationStore.js
import {defineStore} from 'pinia'
import axios from 'axios'

export const useLocationStore = defineStore('location', {
  state: () => ({
    countries: [],
    cities: {},
    isLoading: false,
    error: null,
    pendingRequests: {
      countries: null,  // Здесь будем хранить Promise для запроса стран
      cities: {}        // Здесь будем хранить Promise для запросов городов по ключу страны
    }
  }),

  getters: {
    hasCountries: (state) => state.countries.length > 0,
    getCitiesByCountry: (state) => (countryNumber) => {
      return state.cities[countryNumber] || []
    }
  },

  actions: {
    async fetchCountries() {
      // Если страны уже загружены, не делаем повторный запрос
      if (this.hasCountries) {
        return this.countries
      }

      // Если уже есть активный запрос, возвращаем его
      if (this.pendingRequests.countries) {
        return this.pendingRequests.countries
      }

      this.isLoading = true
      this.error = null

      // Создаем новый запрос и сохраняем его
      this.pendingRequests.countries = axios.get('/get_all_countries', {
        headers: {
          'Accept': 'application/json',
        }
      })
        .then(response => {
          this.countries = response.data
          return this.countries
        })
        .catch(error => {
          console.log(error)
          this.error = error.message
          throw error
        })
        .finally(() => {
          this.isLoading = false
          this.pendingRequests.countries = null
        })

      return this.pendingRequests.countries

    },
    async fetchCities(countryNumber) {
      const key = countryNumber === 'RU' ? 'RU' : countryNumber

      // Если города уже загружены, возвращаем их
      if (this.cities[key]) {
        return this.cities[key]
      }

      // Если уже есть активный запрос для этой страны, возвращаем его
      if (this.pendingRequests.cities[key]) {
        return this.pendingRequests.cities[key]
      }

      this.isLoading = true
      this.error = null

      // Создаем новый запрос и сохраняем его
      this.pendingRequests.cities[key] = axios.get(`/get_world_cities/${key}`, {
        headers: {
          'Accept': 'application/json',
        }
      })
        .then(response => {
          this.cities[key] = response.data
          return this.cities[key]
        })
        .catch(error => {
          console.log(error)
          this.error = error.message
          throw error
        })
        .finally(() => {
          this.isLoading = false
          delete this.pendingRequests.cities[key]
        })

      return this.pendingRequests.cities[key]
    }
  }
})